// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { BroadcastListInfoResponseDTO } from "../../api/backend-openapi";

export const setBroadcastLists = createEvent<BroadcastListInfoResponseDTO[]>(
  "SET_BROADCAST_LISTS"
);
export const addBroadcastList = createEvent<BroadcastListInfoResponseDTO>(
  "ADD_BROADCAST_LIST"
);
export const deleteBroadcastList = createEvent<string>("DELETE_BROADCAST_LIST");
export const updateBroadcastList = createEvent<BroadcastListInfoResponseDTO>(
  "UPDATE_BROADCAST_LIST"
);
